import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from 'src/service/http.service';
import { GlobalcfgService } from '../../../../../../service/globalcfg.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-samples-pending',
  templateUrl: './samples-pending.component.html',
  styleUrls: ['./samples-pending.component.css']
})
export class SamplesPendingComponent implements OnInit {
  filterTerm: any;
  orgList = [];
  orders = [
    {
      name: 'Automatic',
      id: 1
    },
    {
      name: 'Manual',
      id: 2
    }
  ]
  tabs = [
    { heading: "Pending", isSelected: true },
    { heading: "Completed", isSelected: false },
  ];
 
  cars: any = [];
  data: any = [
    {
      "year": "1967",
      "make": "Pontiac",
      "model": "GTO"
    }
  ];
  p: any
  searchTexts: any;
  items: any = [];
  config: any;
  mainData: any;
  radioForm: FormGroup;

  currentTab: string = 'Pending';
  constructor(private httpService: HttpService, private router: Router, private globalcfgService: GlobalcfgService, private formBuilder: FormBuilder,
    private authGuard: AuthGuard , private spinner: NgxSpinnerService) {
    this.loadChallanList();
    for (let key in this.data) {
      if (this.data.hasOwnProperty(key)) {
        this.cars.push(this.data[key])
      }
    }

    this.authGuard.checkIdStatus();
  }

  ngOnInit(): void {
    this.config = {
      currentPage: 1,
      itemsPerPage: 20
    };
  }
  pageChange(newPage: number) {
    this.config.currentPage = newPage;

  }
 
  //onchange method for tabs
  onChange(selectedTab) {
    this.tabs.forEach(tab => {
      if (tab === selectedTab) {
        tab.isSelected = true;
        this.currentTab = tab.heading;
        if (this.currentTab === 'Pending') {
          this.orgList = this.mainData.filter(org => org.samplingStatus == 'Testing in Progress');
          this.orgList.sort((a, b) => (parseInt(a.trayId) > parseInt(b.trayId) ? 1 : -1))


        } else {
          this.orgList = this.mainData.filter(org => org.samplingStatus  != 'Testing in Progress');
          this.orgList.sort((a, b) => (parseInt(a.trayId) > parseInt(b.trayId) ? 1 : -1))

        }

      } else {
        tab.isSelected = false;

      }
    })
  }

  //method for fetching samples
  loadChallanList() {
    const userId = localStorage.getItem('uuid');

    const sampleObj = [
      {
        "_methodId": "40",
        "_userId": userId
    }
    ];
     this.spinner.show();

    this.httpService.getReceivedForTesting(sampleObj).subscribe(data => {
      console.log(data)
      this.spinner.hide();
     
      this.mainData = data['responseData'][1];
      if (this.currentTab === 'Pending') {
        this.orgList = this.mainData.filter(org => org.samplingStatus === 'Testing in Progress');
        this.orgList.sort((a, b) => (parseInt(a.trayId) > parseInt(b.trayId) ? 1 : -1))
      } else {
        this.orgList = this.mainData.filter(org => org.samplingStatus  != 'Testing in Progress');
        this.orgList.sort((a, b) => (parseInt(a.trayId) > parseInt(b.trayId) ? 1 : -1))

      }
    })
  }

  //update sample status
  updateStatus(org) {
    console.log(org)
    Swal.fire({
      title: 'Are you sure to continue',
      icon: 'success',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      customClass: {
        container: 'my-swal-two',
        confirmButton: 'your-confirm-button-class-one',
        cancelButton: 'your-cancel-button-class-one',

      }
    }).then((result) => {
      if(result.value){
        const userId = localStorage.getItem('uuid');
         const sampleObject = [
       
        
          {
              "_methodId": "42",     
              // "_fc":org.fc,
              "_trayId":org.trayId,
              "_userId": userId
          }
      ]
        this.httpService.resultsUpdated(sampleObject).subscribe(result1 => {
        
          if(result1['responseCode']
            === 
            0
            ){
            Swal.fire({
              title: 'Tray Submitted Successfully',
              icon: 'success',
              showCancelButton: false,
              confirmButtonText: 'Yes',
              customClass: {
                container: 'my-swal-two',
                confirmButton: 'your-confirm-button-class-one',
                cancelButton: 'your-cancel-button-class-one',
              }
            }).then((result2) => {
              this.loadChallanList()
            });
          } else {
             alert('Few SampleIds Morphine,Consistency Details not Updated')
          }
  
        })
      }
    
    })


  }


 
  goToViewChallan(org) {
    localStorage.setItem('samplesReceivedData' , JSON.stringify(org))

    this.router.navigate(['/lab-analyst/samples-pending-view',org.trayId]);

  }
  goToUploadResult(org) {
    localStorage.setItem('samplesReceivedData' , JSON.stringify(org))

    this.router.navigate(['/lab-analyst/upload-result',org.trayId]);

  }
}

